import { render } from "./ModalConfirmacion.vue?vue&type=template&id=68619970&scoped=true"
import script from "./ModalConfirmacion.vue?vue&type=script&lang=js"
export * from "./ModalConfirmacion.vue?vue&type=script&lang=js"

import "./ModalConfirmacion.vue?vue&type=style&index=0&id=68619970&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68619970"]])

export default __exports__